import { Component, Input, OnInit, HostListener, TemplateRef, ViewChild, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Lifestyle, Nutrient, Recipe, RecipescoreType } from '../../_model/recipe';
import { LifestyleService } from '../../_service/LifestyleService';
import { AuthService } from 'src/_service/AuthService';
import { SubscriptionService } from 'src/_service/SubscriptionService';
import { environment } from '../../_environments/environment';
import { Router, RouterLink } from '@angular/router';
import { GlobalService } from '../../_service/GlobalService';
import { MediaMatcher } from '@angular/cdk/layout';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { CapitalizeFirstPipe } from '../pipe/capitalizefirst.pipe';
import { VitascoresComponent } from '../vitascores/vitascores.component';
import { ImageComponent } from '../image/image.component';
import { ChipComponent } from '../chip/chip.component';
import { CustomerratingComponent } from '../customerrating/customerrating.component';
import { DecimalPipe, NgClass, isPlatformBrowser } from '@angular/common';
import { WINDOW } from '../../_service/WindowService';
import { DrawerIdentifier, Drawerposition, DrawerService } from 'src/_service/DrawerService';
import { Subject, takeUntil } from 'rxjs';
import { IngredientlistComponent } from "../ingredientlist/ingredientlist.component";
import { WakelockComponent } from "../wakelock/wakelock.component";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-recipe', // render recipe in any type of context
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss'],
  imports: [
    NgClass,
    CustomerratingComponent, ChipComponent, ImageComponent, VitascoresComponent, RouterLink,
    TranslateModule,
    CapitalizeFirstPipe, DecimalPipe,
    IngredientlistComponent,
    WakelockComponent
  ]
})
export class RecipeComponent implements OnInit, OnDestroy {

  _env = environment;

  @ViewChild('bottomdrawer', { static: true }) bottomdrawer: TemplateRef<any>
  scrollStrategy: ScrollStrategy;

  _recipe: Recipe
  @Input() set recipe(value: Recipe) {
    setTimeout(() => {
      this._recipe = value;

      if (value)
        this.initRecipeData(value);
    })

  } // the recipe data is passed in as is to the component

  youtubeUrl: SafeResourceUrl = null;
  vimeoUrl: SafeResourceUrl = null

  lifestyles: Lifestyle[];
  private _persons: number = 2;
  @Input() set personquantity(value: number) {
    if (!value) return;
    value = Number(value)
    if (this._env.subscriptionPersonChoices.includes(value)) {
      this._persons = value
    }
  }
  get personquantity() { return this._persons }

  @Input() popup = false;

  donePreparations: number[] = [];
  vitascores = [];
  isMobile;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.resize();
  }

  private _unsubscribe$ = new Subject<void>();

  constructor(
    // @Inject(OrderService) private _orderService: OrderService,
    // @Inject(SubscriptionService) private _subscriptionService: SubscriptionService,
    public _lifestyleService: LifestyleService,
    private _globalService: GlobalService,
    private _authService: AuthService,
    private _subscriptionService: SubscriptionService,
    private _sso: ScrollStrategyOptions,
    public router: Router,
    private media: MediaMatcher,
    private _drawerService: DrawerService,
    private _sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(WINDOW) private window: Window,
  ) {
  }

  ngOnInit() {

    this.scrollStrategy = this._sso.noop();

    this._drawerService.setDrawer(Drawerposition.bottom, this.bottomdrawer, DrawerIdentifier.recipeBottomDrawer, ' md:w-[500px] mx-auto h-auto', false, true);

    this.isMobile = this.media.matchMedia('(max-width: 960px)').matches;
    // dont show the bottomsheet if a recipe is in a popup, otherwise it will close the layover
    if (!this.popup) {
      setTimeout(() => {
        if (!this.popup) //added extra check for if the boolean is changed in the 100 ms
          this.openBottomsheet();
      }, 100);
    }
  }

  ngOnDestroy() {
    this.closeBottomsheet();
    this._unsubscribe$.next();
  }

  resize() {
    this.isMobile = this.media.matchMedia('(max-width: 960px)').matches;
  }
  scrollToMain() {
    document.getElementById('main').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  openBottomsheet() {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!!this._authService.isAuthenticatedValue) return;
    //this has to be implemented, only the personalmenu flow isnt ready yet
    if (this._subscriptionService.hasSubscriptions) { return; }

    let drawer = this._drawerService.open(DrawerIdentifier.recipeBottomDrawer);
    if (drawer)
      drawer.dismissed.pipe(takeUntil(this._unsubscribe$)).subscribe(() => {
        setTimeout(() => {
          this.closeBottomsheet();
        });
      })

  }
  closeBottomsheet() {
    this._drawerService.close(DrawerIdentifier.recipeBottomDrawer)
    // this.bottomsheetRef.dismiss();
  }

  initRecipeData(recipe: Recipe) {
    // workaround because sometimes we think that 
    if (!!recipe['name']) { return }

    //has a recipeurl if is clicked through by a recipecard, so it can register a pageview, then it is opened in a overlay in stead of a own page.
    if (recipe['recipeurl']) {
      try {
        // these calls will fail in non-browser versions, but we should not care about this there anyway
        const page_view = { // there is a lot of different pageview event formats partly documentent on the web,
          // GTM sends in history change events that could be used to measure pageviews also
          event: 'virtualPageview', // or  "Pageview" ??
          lang: this._globalService.getLanguage(),
          pageUrl: recipe['recipeurl'],
          pageTitle: recipe['recipeurl'] // page title is not  knowns here ...
        };
        this.window['dataLayer'].push(page_view);
      } catch (e) {
      }
    }

    recipe.ingredients = recipe.ingredients.sort((a, b) => a.sequenceid - b.sequenceid);
    recipe.preparations = recipe.preparations.sort((a, b) => a.sequenceid - b.sequenceid);
    const nutrient_order = Object.keys(Nutrient); // we want the order as defined in the enum
    recipe.nutrients = recipe.nutrients.sort((a, b) => nutrient_order.indexOf(a.name) - nutrient_order.indexOf(b.name));
    this._recipe = recipe;

    // get livestyles for recipe
    this._lifestyleService.getLifestyleList().subscribe(
      result => {
        this.lifestyles = result;
        // filters non available lifestyles
        if (this._recipe) {
          this._recipe.lifestyles = this._recipe.lifestyles.filter(l => this.lifestyles.map(s => s.id).includes(l.lifestyleid));
        }
      }
    );

    if (this._recipe.youtubeembedcode)
      this.youtubeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this._recipe.youtubeembedcode}`);
    if (this._recipe.vimeoembedcode)
      this.vimeoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${this._recipe.vimeoembedcode}`);

  };

  getCalories(recipe: Recipe) {
    if (!recipe || !recipe.nutrients) {
      return;
    }
    const calories = recipe.nutrients.find(val => val.name === Nutrient.ENERGY);
    if (calories) {
      return Math.round(calories.quantity);
    } else {
      return null;
    }
  }

  toggleDonePreparation(sequenceid: number) {
    if (!this.donePreparations) {
      return;
    }
    const index = this.donePreparations.indexOf(sequenceid);
    if (index >= 0) {
      this.donePreparations.splice(index, 1);
    } else {
      this.donePreparations.push(sequenceid);
    }
  }

  getLifestyle(lifestyleid: number): Lifestyle {
    if (!this._recipe) {
      return;
    }

    if (!!this.lifestyles) {
      const lifestyle = this.lifestyles.filter(val => val.id === lifestyleid)[0];

      if (lifestyle) {
        return lifestyle;
      } else {
        return null;
      }
    }

  }

  getScore(scoretype: string) {
    // debugger;
    const type = RecipescoreType[scoretype];
    if (!this._recipe || !this._recipe.recipeScores) {
      return { scorerating: '', scorevalue: '0' };
    }

    const res = this._recipe.recipeScores.filter(r => r && r.scoretype == type)[0];
    if (res) {
      return res;
    } else {
      return { scorerating: '0', scorevalue: '0' };
    }
  }

  getRecipecardUrl(): string {
    if (!this._recipe || !this._recipe.recipecards) return null;

    const lang = this._globalService.activeLanguage.language;

    const card = this._recipe.recipecards.find(f => f.language === lang);
    if (!card || !card.recipecardfullurl) return null;
    return this._env.assetserver + card.recipecardfullurl;
  }

}
